// Quiet pointers in AI chats: when it fits, the AI mentions one other part of
// Zuzu in its own words, and a small chip appears under that reply.
// - 'letgo' / 'sky': at most once per chat, only when venting to the AI, never in
//   the first messages and never after anything that sounded like danger.
// - 'bye': when they say goodbye, the AI invites them back (people are here too).
// The browser decides (it knows the chat); the server only words it (lib/aiPrompts.ts).

export type AiNudge = 'letgo' | 'sky' | 'bye';

const LET_GO = /\b(can'?t stop thinking|keep (on )?thinking about|overthink|stuck in my head|out of my head|let (it|this|that) go|move on|racing thoughts|can'?t sleep)\b/i;
const SKY = /\b(no ?one|nobody) (gets|understands|cares)|\b(so|really|very|feel|feeling) (alone|lonely)\b|\bam i the only\b|\bonly one who\b/i;
const BYE = /\b(bye|goodbye|good night|gn|gotta go|got to go|have to go|need to go|i'?ll go now|thanks? (you )?(so much )?for (listening|this|everything|the chat|talking)|that helped|feel(ing)? (a (bit|little) )?better)\b/i;

const words = (t: string) => t.trim().split(/\s+/).filter(Boolean).length;

export function pickNudge(opts: {
  text: string;            // the message just sent
  ventingToAi: boolean;    // the AI listens (not the made-up venter)
  myEarlier: number;       // their messages before this one
  nudged: AiNudge[];       // pointers already shown in this chat
  heavy: boolean;          // this message or an earlier one showed the support card
}): AiNudge | null {
  const { text, ventingToAi, myEarlier, nudged, heavy } = opts;
  if (heavy) return null;
  if (!nudged.includes('bye') && myEarlier >= 3 && words(text) <= 14 && BYE.test(text)) return 'bye';
  if (!ventingToAi || myEarlier < 4 || nudged.some(n => n !== 'bye')) return null;
  if (LET_GO.test(text)) return 'letgo';
  if (SKY.test(text)) return 'sky';
  return null;
}
